import { FaTripadvisor } from "react-icons/fa";
import "./hotel-tripadvisor-rating.scss";

import { TripadvisorRatingComponent } from "../../tripadvisor-rating/tripadvisor-rating.component";

export const HotelTripadvisorRatingComponent = ({
  data,
  contentfulHolidaysComponent,
}) => {
  return (
    <div className="hotel-tripadvisor-rating-component">
      <FaTripadvisor />
      <div className="tripadvisor-rating-container">
        <TripadvisorRatingComponent
          data={parseFloat(data.hotel.rating.tripAdvisorRating)}
        />
      </div>
      <div className="tripadvisor-rating-reviews">
        <p> {data.hotel.rating.tripAdvisorNumberOfReviews}</p>
        <p>
          {contentfulHolidaysComponent &&
            contentfulHolidaysComponent[0]?.fields?.reviews}
        </p>
      </div>
    </div>
  );
};
